import React, { useEffect } from 'react'
import { useState } from 'react'
import Domain from "../../components/forms/domain"
import DashboardLayout from '../../components/layouts/dashboardLayout'
import AppApi from "../../api/app";
import UpdateProfile from '../../components/forms/updateProfile';
import { useSelector } from 'react-redux';
import UpdateSetting from '../../components/forms/updateSetting';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import { Breadcrumb } from 'react-bootstrap';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import UserOrders from '../../components/user/userOrders';
import productApi from '../../api/product';

function ComingSoon() {
   return (
      <div className="container-fluid p-5 text-center">
         <h1>Coming Soon</h1>
         <p>This feature is currently under construction.</p>
      </div>
   )
}
function UserDetails() {
   let { id } = useParams()

   const [loading, setLoading] = useState(false);
   let profile = useSelector(data => data.profile?.data);
   let users = useSelector(data => data.users?.data);
   let [data, setData] = useState({});

   useEffect(() => {
      if (id) {
         let data = users?.data?.filter(data => data._id == id);
         if (data?.length > 0) {
            setData(data[0])
         } else {
            getUserDetails(id)
         }
      }
   }, [])

   const getUserDetails = async (userId) => {
      try {
         setLoading(true);
         productApi.getUserDetails(userId).then(async res => {
            if (res?.data?.error == false) {
               setData(res?.data?.data);
            }
            setLoading(false);
         }).catch(error => {
            setLoading(false);
            console.log("User getting error", error.message)
         })
      } catch (error) {
         setLoading(false);
         console.log("brands getting error", error.message)
      }
   }


   return (
      <>
         <DashboardLayout>
            <div className="container-fluid mt-3">
               <div className="row">
                  <div className="col-12">
                     <Breadcrumb>
                        <Breadcrumb.Item href="#">
                           Dashboard
                        </Breadcrumb.Item>
                        <Breadcrumb.Item >User</Breadcrumb.Item>
                        <Breadcrumb.Item active>Details</Breadcrumb.Item>
                     </Breadcrumb>
                  </div>
               </div>
               <div className="row gap-0">
                  <div className="col-12">
                     <Tab.Container id="left-tabs-example" defaultActiveKey="details">
                        <div className='row gap-0 '>
                           <div className='col-md-2'>
                              <div className="bg-white rounded">
                                 <Nav variant="pills" className="flex-column settingTabs">
                                    <Nav.Item>
                                       <Nav.Link eventKey="details" className="border-bottom">User Details</Nav.Link>
                                    </Nav.Item>
                                    {data?._id && (
                                       <>
                                          <Nav.Item>
                                             <Nav.Link eventKey="orders" className="border-bottom">Order History</Nav.Link>
                                          </Nav.Item>
                                          <Nav.Item>
                                             <Nav.Link eventKey="wishList" className="border-bottom">Wishlist</Nav.Link>
                                          </Nav.Item>
                                          <Nav.Item>
                                             <Nav.Link eventKey="contactUs" className="border-bottom">Contact Information</Nav.Link>
                                          </Nav.Item>
                                          <Nav.Item>
                                             <Nav.Link eventKey="searchHistory">Search History</Nav.Link>
                                          </Nav.Item>
                                       </>
                                    )}
                                 </Nav>
                              </div>
                           </div>
                           <div className='col-md-10'>
                              <div className="bg-white rounded p-3">
                                 <Tab.Content>
                                    <Tab.Pane eventKey="details">
                                       <div className="row">
                                          <div className="col-12">
                                             <h4>Profile Information</h4>
                                             <hr className='my-0' />
                                             {loading ? (
                                                <div className="d-flex justify-content-center align-items-center py-5 my-5">
                                                   <div className="spinner-border text-dark" role="status">
                                                      <span className="sr-only">Loading...</span>
                                                   </div>
                                                </div>
                                             ) : (
                                                <div className="row gap-2 mt-1">
                                                   {!data?._id ? <div>
                                                      <p className='py-5 text-center'>No user found.</p>
                                                   </div> : (
                                                      <>
                                                         <div className="col-md-6">
                                                            <p className='mb-0'><label><b>Name:</b></label> {data?.name}</p>
                                                         </div>
                                                         <div className="col-md-6">
                                                            <p className='mb-0'><label><b>Email:</b></label> {data?.email}</p>
                                                         </div>
                                                         <div className="col-md-6">
                                                            <p className='mb-0'><label><b>Phone:</b></label> {data?.phone}</p>
                                                         </div>
                                                         <div className="col-md-6">
                                                            <p className='mb-0'><label><b>City:</b></label> {data?.city}</p>
                                                         </div>
                                                         <div className="col-md-6">
                                                            <p className='mb-0'> <label><b>Address:</b></label> {data?.address}</p>
                                                         </div>

                                                         <div className="col-md-6">
                                                            <p className='mb-0'><label className='me-2'><b>Status: </b> </label>
                                                               {data?.verified ? <span className="badge bg-success">Verified</span> : <span className="badge bg-danger">Unverified</span>}
                                                            </p>
                                                         </div>
                                                      </>
                                                   )}
                                                </div>
                                             )}
                                          </div>
                                       </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="orders">
                                       {id && <UserOrders userId={id} />}
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="wishList">
                                       <ComingSoon />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="contactUs">
                                       <ComingSoon />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="searchHistory">
                                       <ComingSoon />
                                    </Tab.Pane>
                                 </Tab.Content>
                              </div>
                           </div>
                        </div>
                     </Tab.Container>
                  </div>
               </div>
            </div>
         </DashboardLayout>

      </>
   )
}

export default UserDetails